import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20composition%20of%20fashion%20shopping%20essentials%20featuring%20a%20laptop%20with%20spreadsheet%20open%20on%20screen%20surrounded%20by%20carefully%20arranged%20sneakers%20folded%20designer%20t-shirts%20leather%20accessories%20and%20a%20coffee%20cup%20on%20a%20warm%20cream%20textured%20surface%20soft%20natural%20daylight%20from%20large%20window%20creating%20gentle%20shadows%20editorial%20lifestyle%20photography%20clean%20elegant%20aesthetic%20neutral%20beige%20and%20cream%20tones%20modern%20workspace&width=1800&height=1000&seq=cssbuy-hero-v2-2026&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/45" />

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl">
          <p className="text-accent-400 text-sm font-semibold tracking-wider uppercase mb-3">
            Updated Daily &bull; Trusted by Thousands
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
            CSSBuy <span className="text-accent-300">Spreadsheet</span>
          </h1>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            The most comprehensive directory of CSSBuy spreadsheets, trusted sellers, and shopping guides.
            Discover thousands of products across shoes, clothing, accessories, and more — all in one place.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <Link
              to="/guide/shopping"
              className="px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Shopping Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white text-sm font-semibold rounded-lg hover:bg-white/25 border border-white/20 transition-all whitespace-nowrap"
            >
              Visit Main Website
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}